export default __webpack_public_path__ + "images/6ea320c21409935283cfd3b36bff4dec-djdance.jpg";